// Svenska helgdagar
// Påsk beräknas med Gaussisk algoritm

function passkBerakna(ar) {
  const a = ar % 19
  const b = Math.floor(ar / 100)
  const c = ar % 100
  const d = Math.floor(b / 4)
  const e = b % 4
  const f = Math.floor((b + 8) / 25)
  const g = Math.floor((b - f + 1) / 3)
  const h = (19 * a + b - d - g + 15) % 30
  const i = Math.floor(c / 4)
  const k = c % 4
  const l = (32 + 2 * e + 2 * i - h - k) % 7
  const m = Math.floor((a + 11 * h + 22 * l) / 451)
  const manad = Math.floor((h + l - 7 * m + 114) / 31)
  const dag = ((h + l - 7 * m + 114) % 31) + 1
  return new Date(ar, manad - 1, dag)
}

function datumStr(d) {
  return `${d.getFullYear()}-${String(d.getMonth()+1).padStart(2,'0')}-${String(d.getDate()).padStart(2,'0')}`
}

function addDagar(d, n) {
  const ny = new Date(d)
  ny.setDate(ny.getDate() + n)
  return ny
}

export function hamtaHelgdagar(ar) {
  const pask = passkBerakna(ar)
  const helgdagar = {}

  // Fasta helgdagar
  helgdagar[`${ar}-01-01`] = 'Nyårsdagen'
  helgdagar[`${ar}-01-06`] = 'Trettondedag jul'
  helgdagar[`${ar}-05-01`] = 'Första maj'
  helgdagar[`${ar}-06-06`] = 'Nationaldagen'
  helgdagar[`${ar}-12-24`] = 'Julafton'
  helgdagar[`${ar}-12-25`] = 'Juldagen'
  helgdagar[`${ar}-12-26`] = 'Annandag jul'
  helgdagar[`${ar}-12-31`] = 'Nyårsafton'

  // Påskrelaterade
  helgdagar[datumStr(addDagar(pask, -3))] = 'Skärtorsdagen'
  helgdagar[datumStr(addDagar(pask, -2))] = 'Långfredagen'
  helgdagar[datumStr(addDagar(pask, -1))] = 'Påskafton'
  helgdagar[datumStr(pask)]               = 'Påskdagen'
  helgdagar[datumStr(addDagar(pask, 1))]  = 'Annandag påsk'
  helgdagar[datumStr(addDagar(pask, 39))] = 'Kristi himmelsfärdsdag'
  helgdagar[datumStr(addDagar(pask, 49))] = 'Pingstdagen'
  helgdagar[datumStr(addDagar(pask, 50))] = 'Annandag pingst'

  // Midsommar – fredag mellan 19-25 juni
  for (let d = 19; d <= 25; d++) {
    const dt = new Date(ar, 5, d)
    if (dt.getDay() === 5) {
      helgdagar[datumStr(dt)] = 'Midsommarafton'
      helgdagar[datumStr(addDagar(dt, 1))] = 'Midsommardagen'
      break
    }
  }

  // Alla helgons dag – lördag mellan 31 okt - 6 nov
  for (let d = 31; d <= 37; d++) {
    const dt = new Date(ar, d > 31 ? 10 : 9, d > 31 ? d - 31 : d)
    if (dt.getDay() === 6) {
      helgdagar[datumStr(dt)] = 'Alla helgons dag'
      break
    }
  }

  return helgdagar
}
